export function checkShopOpenDate(date, isValidZipcode) {
    const now = new Date();
    const holidays = window.sharedResources.holidays || {},
          isSunday = date.getDay() === 0,
          isSaturday = date.getDay() === 6 && !isValidZipcode,
          ymd = formatDateYMD(date),
          isHoliday = holidays.includes(ymd),
          isException = ["02-14", "05-30", "11-14"].includes(ymd.substr(5)),
          isToday = formatDateYMD(now) === ymd && now.getHours() >= 14
    return (!isSunday && !isHoliday && !isSaturday && !isToday) || isException
    // return isSunday || isHoliday ? [false, ''] : [true, '']
}

export function formatDateYMD(date) {
    return `${date.getFullYear()}-${pad2(date.getMonth() + 1)}-${pad2(date.getDate())}`
}

function pad2(num) {
    return num < 10 ? `0${num}` : num
}
